<template>
  <div>
    <section-definition title="Planos de Quadro Horário" event-update="pesquisar"></section-definition>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Gerenciar Planos de Quadro Horário</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <modal-cadastro-qh-plano @qhPlanoCadastrado="cadastroEfetuado = $event"/>
    </v-toolbar>
    <v-container fluid>
      <v-form @submit.prevent="pesquisar()" ref="form" class="hidden-sm-and-down">
        <v-layout align-center row fill-height justify-space-between>
          <v-flex xs12 sm6 md3>
            <v-select v-model="filtro.ano" :items="anos" label="Ano" clearable
              @change="aoSelecionarAno"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-select v-model="filtro.numero" :items="numeros" label="Número" clearable
              :disabled="!filtro.ano" @change="pesquisar"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-btn color="primary" alt="Limpar" title="Limpar" @click="limpar()"><v-icon>clear</v-icon></v-btn>
            <v-btn color="primary" alt="Pesquisar" title="Pesquisar" type="submit"><v-icon>find_in_page</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      <v-data-table :loading="loading" :headers="headers" :items="qhPlanos" class="elevation-1"
        :total-items="pagination.totalItems" :pagination.sync="pagination">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.ano }}</td>
          <td>{{ props.item.numero }}</td>
          <td>{{ props.item.descricao }}</td>
          <td>{{ props.item.dataInicio }}</td>
          <td>{{ props.item.dataFim }}</td>
          <td>{{ props.item.ativo ? "Sim" : "Não" }}</td>
          <td>
            <v-icon v-if="props.item.ativo" title="Editar" medium class="mr-2" @click="editar(props.item)">
              edit
            </v-icon>
            <v-icon :title="props.item.ativo ? 'Desativar' : 'Ativar'" medium class="mr-2" @click="alternarAtivo(props.item)">
              {{ props.item.ativo ? 'toggle_on' : 'toggle_off' }}
            </v-icon>
            <v-icon title="Excluir" medium class="mr-2" @click="excluir(props.item)">
              delete
            </v-icon>
          </td>
        </template>
        <template slot="no-data">
          Plano de quadro horário não localizado!
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import qhPlanoService from "@/service/qh/QhPlanoService";
import QhPlano from "@/model/qh/QhPlano";
import EventBus from "@/utils/EventBus.js";
import Pagination from "@/utils/Pagination.js";
import ModalCadastroQhPlano from "./ModalCadastroQhPlano";
export default {
  components: {
    ModalCadastroQhPlano
  },
  data() {
    return {
      loading: true,
      pagination: new Pagination(1, 10),
      cadastroEfetuado: false,
      qhPlanos: [],
      anos: [],
      numeros: [],
      filtro: new QhPlano(),
      headers: [
        { text: "Ano", align: "left", sortable: false, value: "ano" },
        { text: "Número", align: "left", sortable: false, value: "numero" },
        { text: "Descrição", align: "left", sortable: false, value: "descricao" },
        { text: "Data Início", align: "left", sortable: false, value: "dataInicio" },
        { text: "Data Fim", align: "left", sortable: false, value: "dataFim" },
        { text: "Ativo", align: "left", sortable: false, value: "ativo" },
        { text: "Ações", value: "name", sortable: false }
      ]
    };
  },
  watch: {
    cadastroEfetuado(event) {
      if (event) {
        setTimeout(() => {
          this.carregarAnos();
          this.pesquisar();
          this.cadastroEfetuado = false;
        }, 500);
      }
    },
    pagination: {
      handler() {
        this.pesquisar();
      }
    }
  },
  created() {
    this.carregarAnos();
  },
  methods: {
    async carregarAnos() {
      this.anos = await qhPlanoService.listarAnos();
    },
    async aoSelecionarAno() {
      this.filtro.numero = null;
      if (this.filtro.ano) {
        this.numeros = await qhPlanoService.listarNumeros(this.filtro.ano);
      } else {
        this.numeros = [];
      }
      this.pesquisar();
    },
    limpar() {
      this.filtro = new QhPlano();
      this.numeros = [];
      this.pesquisar();
    },
    async pesquisar() {
      this.loading = true;
      const paginacaoResultado = await qhPlanoService.listarTodos(
        this.filtro,
        this.pagination.page,
        this.pagination.rowsPerPage
      );
      if (paginacaoResultado) {
        this.qhPlanos = paginacaoResultado.dados || [];
        this.pagination.totalItems = paginacaoResultado.total;
      } else {
        this.qhPlanos = [];
        this.pagination.totalItems = 0;
      }
      this.loading = false;
    },
    editar(plano) {
      EventBus.$emit("editaQhPlano", plano.id);
    },
    alternarAtivo(plano) {
      const acao = plano.ativo ? "desativar" : "ativar";
      confirm("Você deseja realmente " + acao + " o Plano?") &&
        qhPlanoService.alternarAtivo(plano).then(retorno => {
          if (retorno) {
            this.pesquisar();
          }
        });
    },
    excluir(plano) {
      confirm("Você deseja realmente excluir o Plano?") &&
        qhPlanoService.excluir(plano).then(retorno => {
          if (retorno) {
            this.qhPlanos.splice(this.qhPlanos.indexOf(plano), 1);
            this.carregarAnos();
            this.pesquisar();
          }
        });
    }
  }
};
</script>
